// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b643245e","239":"e9729694","455":"700a7abe"}[chunkId] + ".chunk.js";
};